import { connect } from 'react-redux'
import { removeFilter, setFilterText, clearFilter } from '../actions/filter'
import ActiveFilterList from '../components/active-filter-list'

const mapStateToProps = (state) => {
	return {
		filter: state.filter
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		onFilterClick: (filterName, filterValue) => {
			dispatch(removeFilter(filterName, filterValue))
		},
		onTextFilterClick: () => {
			dispatch(setFilterText(''))
		},
		onClearFiltersClick: () => {
			dispatch(clearFilter())
		}
	}
}

const ActiveFilterListContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(ActiveFilterList)

export default ActiveFilterListContainer
